// Copyright (C) 2021 TANNER AG

import React from "react";

const EMobilityVideo = ({ src }) => {
    return (
        <iframe
            title={src}
            width="720"
            height="405"
            src={src}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
        />
    );
};

export default EMobilityVideo;



// WEBPACK FOOTER //
// ./src/emobility/EMobilityVideo.js